import axios from "axios";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router";
import Breadcrumbs from "../../components/Common/Breadcrumbs/Breadcrumbs";
import { convertToTitleCase, slugUrl } from "../../components/Constants";
import SucessModal from "../../components/Modal/SucessModal";

const AddFrpCity = ({ edit = false }) => {
  const [success, setSuccess] = useState(false);
  const [checked, setChecked] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const stateSlug = edit
    ? location.pathname.split("/")[2]
    : location.pathname.split("/")[3];
  const citySlug = location.pathname.split("/")[4];

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (stateSlug) {
      setValue("state", convertToTitleCase(stateSlug));
    }
  }, [stateSlug, setValue]);

  const getCity = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}frp-states/${stateSlug}/get-city/${citySlug}`,
      )
      .then((response) => {
        setValue("city", response?.data?.city);
        setChecked(response?.data?.active || false);
      });
  };

  useEffect(() => {
    edit && citySlug && getCity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [citySlug]);

  const onSubmit = (fields) => {
    fields.slug_url = slugUrl(fields.city);
    if (edit) {
      axios
        .post(
          `${process.env.REACT_APP_API_URL}frp-states/${stateSlug}/edit-city/${citySlug}`,
          fields,
        )
        .then((response) => {
          if (response.status === 200) {
            setSuccess(true);
          } else {
            alert("Failed to edit city. Please try again");
            console.log("failed...");
          }
        });
    } else {
      axios
        .post(
          `${process.env.REACT_APP_API_URL}frp-states/create-city/${stateSlug}`,
          fields,
        )
        .then((response) => {
          if (response.status === 200) {
            setSuccess(true);
          } else {
            alert("Failed to add city. Please try again");
            console.log("failed...");
          }
        });
    }
  };

  return (
    <>
      <div className="healtharticle mt-5 pt-3 ps-2">
        <Breadcrumbs
          breadcrumbText="FRP"
          breadcrumbLink="/frp-states"
          nestedText="View Cities"
          nestedLink={`/frp-states/${stateSlug}/view-cities`}
          nestedText2={edit ? "Edit City" : "Add New City"}
          nestedLink2="#"
        />
        <form className="carr-dep-form" onSubmit={handleSubmit(onSubmit)}>
          <div className="row car-dep-form">
            <div className="col-6">
              <label
                className="car-dep-form-txt mb-2"
                style={{ color: "#4B4853" }}
                htmlFor=""
              >
                Select State <span className="star">*</span>
              </label>
              <select
                className="form-control w-75"
                {...register("state")}
                defaultValue={stateSlug ? stateSlug : ""}
                disabled={stateSlug}
              >
                <option value={convertToTitleCase(stateSlug)}>
                  {convertToTitleCase(stateSlug)}
                </option>
              </select>
            </div>

            <div className="col-6">
              <label
                className="car-dep-form-txt mb-2"
                style={{ color: "#4B4853" }}
                htmlFor=""
              >
                City <span className="star">*</span>
              </label>
              <input
                className="form-control w-75"
                type="text"
                name=""
                id="type"
                placeholder="Enter city"
                {...register("city", { required: true })}
              />
              {errors.city && (
                <div className={`invalid-feedback d-block`}>
                  Please Enter city
                </div>
              )}
            </div>
            <div className="col-6 mt-5">
              <label
                className="car-dep-form-txt mb-2"
                style={{ color: "#4B4853" }}
                htmlFor=""
              >
                Active <span className="star">*</span>
              </label>
              <div className="d-flex">
                <div className="form-check form-check-inline d-flex align-items-center me-3 mt-1">
                  <input
                    className="form-check-input me-3"
                    type="radio"
                    name="status"
                    id="status"
                    value={true}
                    checked={checked}
                    onClick={() => setChecked(true)}
                    {...register("active", { required: true })}
                  />
                  <label htmlFor="option-1" className="text-dark ">
                    Yes
                  </label>
                </div>
                <div className="form-check form-check-inline d-flex align-items-center mt-1">
                  <input
                    className="form-check-input me-3"
                    type="radio"
                    name="status"
                    id="status"
                    value={false}
                    checked={!checked}
                    onClick={() => setChecked(false)}
                    {...register("active", { required: true })}
                  />
                  <label htmlFor="option-2" className="text-dark">
                    No
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="car-dep-form-button m-0 pt-5">
            <button type="submit">SUBMIT</button>
          </div>
        </form>
      </div>
      {success && (
        <SucessModal
          page={`/frp-states/view-cities/${stateSlug}`}
          name="City"
          post={edit ? "updated" : "added"}
          onClick={() => navigate(`/frp-states/view-cities/${stateSlug}`)}
        />
      )}
    </>
  );
};

export default AddFrpCity;
